import { Link } from '@global-ecom/nitro-uds/elements';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { useIsCrawler } from 'hooks/useIsCrawler';
import { ProductTypeFromPDPQuery } from 'types/product';
import { useCategoryByIdQuery } from '__generated__/graphql';
import { isServer } from 'utils/constants';
import { useTranslate } from 'hooks/useTranslations';
import { constructCategoryPath } from 'utils/constructCategoryPath';

type ExploreCollectionCtaType = {
  masterProduct?: ProductTypeFromPDPQuery;
};

export const ExploreCollectionCta = (props: ExploreCollectionCtaType) => {
  const t = useTranslate();
  const { localizeUrlPath } = useSiteConfig();
  const isCrawler = useIsCrawler();
  const {
    primaryCategoryId: defaultCategoryId,
    showExploreCollectionCTA,
    exploreMoreCTALabel,
    exploreMoreCTATargetCategoryID: targetCategoryId,
  } = props.masterProduct ?? {};

  const categoryId = targetCategoryId ?? defaultCategoryId;

  const [categoryByIdQuery] = useCategoryByIdQuery({
    variables: {
      id: categoryId!,
    },
    pause: !categoryId || isServer,
  });

  if (!showExploreCollectionCTA || !categoryId) return null;

  const categoryById = categoryByIdQuery.data?.categoryById;

  if (!categoryById) return null;

  const categoryUrls = constructCategoryPath(categoryById);
  const url = categoryUrls[categoryUrls.length - 1].url;
  const defaultExploreMoreLabel = t('exploreCollection');

  return (
    <Link
      dataTestId="explore-this-collection-cta"
      href={isCrawler ? localizeUrlPath(url, true) : url}
      label={exploreMoreCTALabel ?? defaultExploreMoreLabel}
      variant="secondary"
      size="lg"
    />
  );
};
